import React from "react";
import {Result} from "antd";

const BuildingPage:React.FC = () => {

    return (
        <Result
            status="403"
            title=""
            subTitle="功能开发中"
        />
    );

}

export default BuildingPage;